// FistOS control protocol — telephony, SMS and notification events and
// controls.
//
// Event payloads (numbers, bodies, titles) are UNTRUSTED data
// (AGENTS.md §5.4) and are never logged at info or above (§5.6).
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file events.proto.
 */
export const file_events = /*@__PURE__*/ fileDesc("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");
/**
 * Describes the message fistos.v1.CallEvent.
 * Use `create(CallEventSchema)` to create a new message.
 */
export const CallEventSchema = /*@__PURE__*/ messageDesc(file_events, 0);
/**
 * Describes the message fistos.v1.CallState.
 * Use `create(CallStateSchema)` to create a new message.
 */
export const CallStateSchema = /*@__PURE__*/ messageDesc(file_events, 1);
/**
 * Describes the message fistos.v1.CallControl.
 * Use `create(CallControlSchema)` to create a new message.
 */
export const CallControlSchema = /*@__PURE__*/ messageDesc(file_events, 2);
/**
 * Describes the message fistos.v1.Dial.
 * Use `create(DialSchema)` to create a new message.
 */
export const DialSchema = /*@__PURE__*/ messageDesc(file_events, 3);
/**
 * Describes the message fistos.v1.Answer.
 * Use `create(AnswerSchema)` to create a new message.
 */
export const AnswerSchema = /*@__PURE__*/ messageDesc(file_events, 4);
/**
 * Describes the message fistos.v1.Hangup.
 * Use `create(HangupSchema)` to create a new message.
 */
export const HangupSchema = /*@__PURE__*/ messageDesc(file_events, 5);
/**
 * Describes the message fistos.v1.Hold.
 * Use `create(HoldSchema)` to create a new message.
 */
export const HoldSchema = /*@__PURE__*/ messageDesc(file_events, 6);
/**
 * Describes the message fistos.v1.Mute.
 * Use `create(MuteSchema)` to create a new message.
 */
export const MuteSchema = /*@__PURE__*/ messageDesc(file_events, 7);
/**
 * Describes the message fistos.v1.Dtmf.
 * Use `create(DtmfSchema)` to create a new message.
 */
export const DtmfSchema = /*@__PURE__*/ messageDesc(file_events, 8);
/**
 * Describes the message fistos.v1.SetAudioRoute.
 * Use `create(SetAudioRouteSchema)` to create a new message.
 */
export const SetAudioRouteSchema = /*@__PURE__*/ messageDesc(file_events, 9);
/**
 * Describes the message fistos.v1.StreamCallAudio.
 * Use `create(StreamCallAudioSchema)` to create a new message.
 */
export const StreamCallAudioSchema = /*@__PURE__*/ messageDesc(file_events, 10);
/**
 * Describes the message fistos.v1.SetCallForwarding.
 * Use `create(SetCallForwardingSchema)` to create a new message.
 */
export const SetCallForwardingSchema = /*@__PURE__*/ messageDesc(file_events, 11);
/**
 * Describes the message fistos.v1.GetCallState.
 * Use `create(GetCallStateSchema)` to create a new message.
 */
export const GetCallStateSchema = /*@__PURE__*/ messageDesc(file_events, 12);
/**
 * Describes the message fistos.v1.SmsEvent.
 * Use `create(SmsEventSchema)` to create a new message.
 */
export const SmsEventSchema = /*@__PURE__*/ messageDesc(file_events, 13);
/**
 * Describes the message fistos.v1.SmsSend.
 * Use `create(SmsSendSchema)` to create a new message.
 */
export const SmsSendSchema = /*@__PURE__*/ messageDesc(file_events, 14);
/**
 * Describes the message fistos.v1.SmsThreadSummary.
 * Use `create(SmsThreadSummarySchema)` to create a new message.
 */
export const SmsThreadSummarySchema = /*@__PURE__*/ messageDesc(file_events, 15);
/**
 * Describes the message fistos.v1.SmsThreadList.
 * Use `create(SmsThreadListSchema)` to create a new message.
 */
export const SmsThreadListSchema = /*@__PURE__*/ messageDesc(file_events, 16);
/**
 * Describes the message fistos.v1.NotificationEvent.
 * Use `create(NotificationEventSchema)` to create a new message.
 */
export const NotificationEventSchema = /*@__PURE__*/ messageDesc(file_events, 17);
/**
 * @generated from enum fistos.v1.CallStateKind
 */
export var CallStateKind;
(function (CallStateKind) {
    /**
     * @generated from enum value: CALL_STATE_UNSPECIFIED = 0;
     */
    CallStateKind[CallStateKind["CALL_STATE_UNSPECIFIED"] = 0] = "CALL_STATE_UNSPECIFIED";
    /**
     * @generated from enum value: CALL_STATE_RINGING = 1;
     */
    CallStateKind[CallStateKind["CALL_STATE_RINGING"] = 1] = "CALL_STATE_RINGING";
    /**
     * @generated from enum value: CALL_STATE_DIALING = 2;
     */
    CallStateKind[CallStateKind["CALL_STATE_DIALING"] = 2] = "CALL_STATE_DIALING";
    /**
     * @generated from enum value: CALL_STATE_ACTIVE = 3;
     */
    CallStateKind[CallStateKind["CALL_STATE_ACTIVE"] = 3] = "CALL_STATE_ACTIVE";
    /**
     * @generated from enum value: CALL_STATE_HOLDING = 4;
     */
    CallStateKind[CallStateKind["CALL_STATE_HOLDING"] = 4] = "CALL_STATE_HOLDING";
    /**
     * @generated from enum value: CALL_STATE_DISCONNECTED = 5;
     */
    CallStateKind[CallStateKind["CALL_STATE_DISCONNECTED"] = 5] = "CALL_STATE_DISCONNECTED";
    /**
     * @generated from enum value: CALL_STATE_CONNECTING = 6;
     */
    CallStateKind[CallStateKind["CALL_STATE_CONNECTING"] = 6] = "CALL_STATE_CONNECTING";
})(CallStateKind || (CallStateKind = {}));
/**
 * Describes the enum fistos.v1.CallStateKind.
 */
export const CallStateKindSchema = /*@__PURE__*/ enumDesc(file_events, 0);
/**
 * @generated from enum fistos.v1.CallAudioRoute
 */
export var CallAudioRoute;
(function (CallAudioRoute) {
    /**
     * @generated from enum value: CALL_AUDIO_ROUTE_UNSPECIFIED = 0;
     */
    CallAudioRoute[CallAudioRoute["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CALL_AUDIO_ROUTE_EARPIECE = 1;
     */
    CallAudioRoute[CallAudioRoute["EARPIECE"] = 1] = "EARPIECE";
    /**
     * @generated from enum value: CALL_AUDIO_ROUTE_SPEAKER = 2;
     */
    CallAudioRoute[CallAudioRoute["SPEAKER"] = 2] = "SPEAKER";
    /**
     * @generated from enum value: CALL_AUDIO_ROUTE_BLUETOOTH = 3;
     */
    CallAudioRoute[CallAudioRoute["BLUETOOTH"] = 3] = "BLUETOOTH";
    /**
     * @generated from enum value: CALL_AUDIO_ROUTE_WIRED_HEADSET = 4;
     */
    CallAudioRoute[CallAudioRoute["WIRED_HEADSET"] = 4] = "WIRED_HEADSET";
    /**
     * Audio is relayed to/from the control server (§7.2/§7.3).
     *
     * @generated from enum value: CALL_AUDIO_ROUTE_REMOTE = 5;
     */
    CallAudioRoute[CallAudioRoute["REMOTE"] = 5] = "REMOTE";
})(CallAudioRoute || (CallAudioRoute = {}));
/**
 * Describes the enum fistos.v1.CallAudioRoute.
 */
export const CallAudioRouteSchema = /*@__PURE__*/ enumDesc(file_events, 1);
/**
 * @generated from enum fistos.v1.CallForwardingReason
 */
export var CallForwardingReason;
(function (CallForwardingReason) {
    /**
     * @generated from enum value: CALL_FORWARDING_UNCONDITIONAL = 0;
     */
    CallForwardingReason[CallForwardingReason["CALL_FORWARDING_UNCONDITIONAL"] = 0] = "CALL_FORWARDING_UNCONDITIONAL";
    /**
     * @generated from enum value: CALL_FORWARDING_BUSY = 1;
     */
    CallForwardingReason[CallForwardingReason["CALL_FORWARDING_BUSY"] = 1] = "CALL_FORWARDING_BUSY";
    /**
     * @generated from enum value: CALL_FORWARDING_NO_REPLY = 2;
     */
    CallForwardingReason[CallForwardingReason["CALL_FORWARDING_NO_REPLY"] = 2] = "CALL_FORWARDING_NO_REPLY";
    /**
     * @generated from enum value: CALL_FORWARDING_NOT_REACHABLE = 3;
     */
    CallForwardingReason[CallForwardingReason["CALL_FORWARDING_NOT_REACHABLE"] = 3] = "CALL_FORWARDING_NOT_REACHABLE";
})(CallForwardingReason || (CallForwardingReason = {}));
/**
 * Describes the enum fistos.v1.CallForwardingReason.
 */
export const CallForwardingReasonSchema = /*@__PURE__*/ enumDesc(file_events, 2);
